import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import FeedbackProvider from './components/feedback/FeedbackProvider';
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<ThemeProvider theme={theme}>
		<CssBaseline />
		<FeedbackProvider>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</FeedbackProvider>
	</ThemeProvider>
);
